

import React, { useState, useRef, useEffect } from "react";
import { Button, Form, Input, Alert,Row,Col, Switch } from "antd";
import { Link } from "react-router-dom";
import DisabledPerson from "../assets/images/disabled-person.svg";
import "../css/components.css"
import { SwitchChangeEventHandler } from "antd/lib/switch";

type DisabledPersonProps = {
    onToggleChange:SwitchChangeEventHandler;
    isDisabled:boolean
}

function DifferentlyAbled(props:DisabledPersonProps) {
  const{onToggleChange,isDisabled}=props

  return (

          <div className="diff_able_container" >
            <div className="diff_able_content">
            <div className="diff_able_text">
        <img src={DisabledPerson}/>
        <div className="diff_able_text_container">
            <text>Differently-abled?</text>
            <br/>
            <text>Switch on if you are a differently-abled person</text>

        </div>
        </div>
        <div >
        <Switch onChange={onToggleChange} checked={isDisabled}/>
        </div>
        </div>
          </div>
 
  );
}

export default DifferentlyAbled;
